module.exports = __webpack_public_path__ + "img/QRcode.c68b35c8.png";